var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "items"
  }, _vm._l(_vm.schemas, function (item) {
    return _c('div', {
      key: item.name,
      staticClass: "item el-bg-color-gray-4-hover"
    }, [_c('div', {
      staticClass: "item__wrapper"
    }, [_c('span', {
      staticClass: "item__name el-color-gray-8"
    }, [_vm._v(_vm._s(item.name))]), _c('el-button', {
      staticClass: "item__btn",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function ($event) {
          return _vm.handleFixedChange(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.isFixed ? '取消置顶' : '置顶') + " ")]), _c('el-button', {
      staticClass: "item__btn",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function ($event) {
          return _vm.handleDelete(item);
        }
      }
    }, [_vm._v(" 删除 ")])], 1)]);
  }), 0);
};

var staticRenderFns = [];
export { render, staticRenderFns };